import { render, staticRenderFns } from "./AddCMPage.vue?vue&type=template&id=31d400a6&"
import script from "./AddCMPage.vue?vue&type=script&lang=js&"
export * from "./AddCMPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports